import { gql } from '@apollo/client';

const removeByIdCourseMetricDefinitionMutation = gql`
  mutation RemoveByIdCourseMetricDefinition($_id: MongoID!) {
    removeByIdCourseMetricDefinition(_id: $_id) {
      recordId
    }
  }
`;

export default removeByIdCourseMetricDefinitionMutation;
